/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import { Fragment } from 'react';
import * as dc from '@/lib/dc';
import { PagerButton, SegmentedOption } from '@pointfive/ui';
import type { ViewModel } from './view-model';

export function DashboardView({ m }: { m: ViewModel }) {
  return (
    <>
      {' '}
      <div style={{ padding: '16px 12px 28px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
        {' '}
        {m.showFxTicker ? (
          <>
            {' '}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0',
                overflowX: 'auto',
                padding: '9px 2px',
                borderTop: '1px solid var(--l6)',
                borderBottom: '1px solid var(--l6)',
              }}
            >
              {' '}
              {(m.ticker ?? []).map((t, i0) => (
                <Fragment key={i0}>
                  {' '}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'baseline',
                      gap: '8px',
                      padding: '0 18px',
                      borderRight: '1px solid var(--l8)',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {' '}
                    <span style={{ fontSize: '12px', fontWeight: '600' }}>{dc.t(t?.pair)}</span>{' '}
                    <span
                      style={{
                        fontSize: '12.5px',
                        fontVariantNumeric: 'tabular-nums',
                        color: 'var(--text2)',
                      }}
                    >
                      {dc.t(t?.px)}
                    </span>{' '}
                    <span
                      style={dc.css(`font-size:11px;font-variant-numeric:tabular-nums;color:${dc.s(t?.col)}`)}
                    >
                      {dc.t(t?.chg)}
                    </span>{' '}
                  </div>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
          </>
        ) : null}{' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            padding: '14px 20px 12px',
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
          }}
        >
          {' '}
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'space-between',
              gap: '16px',
              flexWrap: 'wrap',
            }}
          >
            {' '}
            <div style={{ minWidth: '150px' }}>
              {' '}
              <div
                style={{
                  fontSize: '9.5px',
                  letterSpacing: '0.13em',
                  textTransform: 'uppercase',
                  color: 'var(--muted2)',
                  fontWeight: '600',
                }}
              >
                Net P&L
              </div>{' '}
              <div
                style={{
                  fontSize: '28px',
                  fontWeight: '600',
                  letterSpacing: '-0.02em',
                  fontVariantNumeric: 'tabular-nums',
                  marginTop: '2px',
                  whiteSpace: 'nowrap',
                  lineHeight: '1.1',
                }}
              >
                {dc.t(m.eqTotal)}
              </div>{' '}
            </div>{' '}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '2px',
                padding: '3px',
                borderRadius: '99px',
                border: '1px solid var(--l8)',
                flex: 'none',
              }}
            >
              {' '}
              {(m.eqRanges ?? []).map((r, i1) => (
                <Fragment key={i1}>
                  {' '}
                  <SegmentedOption
                    bg={r?.bg}
                    fg={r?.fg}
                    fw={r?.fw}
                    variant="a"
                    onClick={r?.go}
                    hoverClass="scp-4f3e86a"
                  >
                    {dc.t(r?.label)}
                  </SegmentedOption>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
          </div>{' '}
          <div style={{ display: 'flex', alignItems: 'stretch', gap: '18px', flexWrap: 'wrap' }}>
            {' '}
            <div
              style={{
                flex: '1 1 260px',
                minWidth: '240px',
                display: 'flex',
                flexDirection: 'column',
                gap: '6px',
              }}
            >
              {' '}
              <div
                style={{
                  flex: '1',
                  minHeight: '120px',
                  display: 'flex',
                  alignItems: 'stretch',
                  gap: '3px',
                  position: 'relative',
                }}
              >
                {' '}
                <div
                  style={dc.css(
                    `position:absolute;left:0;right:0;top:${dc.s(m.eqPosShare)};height:1px;background:var(--l10);pointer-events:none`,
                  )}
                ></div>{' '}
                {(m.eqBars ?? []).map((b, i2) => (
                  <Fragment key={i2}>
                    {' '}
                    <div
                      onMouseEnter={b?.hEnter}
                      onMouseMove={b?.hMove}
                      onMouseLeave={b?.hLeave}
                      onClick={b?.click}
                      role="button"
                      tabIndex={0}
                      aria-label={dc.a(b?.tipText)}
                      style={dc.css(
                        `flex:1;min-width:0;display:flex;flex-direction:column;cursor:pointer;margin-left:${dc.s(b?.ml)}`,
                      )}
                    >
                      {' '}
                      <div
                        style={dc.css(
                          `flex:0 0 ${dc.s(m.eqPosShare)};display:flex;align-items:flex-end;padding-bottom:1px`,
                        )}
                      >
                        {' '}
                        <div
                          style={dc.css(
                            `width:100%;height:${dc.s(b?.upH)};min-height:${dc.s(b?.upMin)};border-radius:${dc.s(b?.radTop)};background:${dc.s(b?.upBg)};background-image:${dc.s(b?.upImg)};background-size:6px 6px;border:${dc.s(b?.upBorder)};box-sizing:border-box`,
                          )}
                        ></div>{' '}
                      </div>{' '}
                      <div
                        style={dc.css(
                          `flex:0 0 ${dc.s(m.eqNegShare)};display:flex;align-items:flex-start;padding-top:1px`,
                        )}
                      >
                        {' '}
                        <div
                          style={dc.css(
                            `width:100%;height:${dc.s(b?.dnH)};min-height:${dc.s(b?.dnMin)};border-radius:${dc.s(b?.radBot)};background:${dc.s(b?.dnBg)};background-image:${dc.s(b?.dnImg)};background-size:6px 6px;border:${dc.s(b?.dnBorder)};box-sizing:border-box`,
                          )}
                        ></div>{' '}
                      </div>{' '}
                    </div>{' '}
                  </Fragment>
                ))}{' '}
              </div>{' '}
              <div style={{ display: 'flex', gap: '3px', padding: '0 6px' }}>
                {' '}
                {(m.eqBars ?? []).map((b, i3) => (
                  <Fragment key={i3}>
                    {' '}
                    <span
                      style={dc.css(
                        `flex:1;min-width:0;text-align:center;font-size:9px;font-weight:${dc.s(b?.lblFw)};color:${dc.s(b?.lblFg)};white-space:nowrap;overflow:visible;margin-left:${dc.s(b?.ml)}`,
                      )}
                    >
                      {dc.t(b?.label)}
                    </span>{' '}
                  </Fragment>
                ))}{' '}
              </div>{' '}
            </div>{' '}
            <div
              style={{
                flex: '0 1 auto',
                minWidth: '112px',
                maxWidth: '150px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'flex-end',
                textAlign: 'right',
                gap: '3px',
                paddingLeft: '14px',
                borderLeft: '1px solid var(--l8)',
              }}
            >
              {' '}
              <div
                style={{
                  fontSize: '9.5px',
                  letterSpacing: '0.13em',
                  textTransform: 'uppercase',
                  color: 'var(--muted2)',
                  fontWeight: '600',
                }}
              >
                {dc.t(m.eqTodayLabel)}
              </div>{' '}
              <div
                style={dc.css(
                  `font-size:22px;font-weight:600;color:${dc.s(m.eqTodayCol)};font-variant-numeric:tabular-nums;white-space:nowrap`,
                )}
              >
                {dc.t(m.eqToday)}
              </div>{' '}
              <div style={{ fontSize: '10.5px', color: 'var(--muted)' }}>{dc.t(m.eqTodaySub)}</div>{' '}
              <div style={{ fontSize: '10px', color: 'var(--muted)', marginTop: '4px' }}>
                {dc.t(m.eqGranularity)}
              </div>{' '}
            </div>{' '}
          </div>{' '}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              flexWrap: 'wrap',
              paddingTop: '10px',
              borderTop: '1px solid var(--l6)',
            }}
          >
            {' '}
            <span
              style={{
                fontSize: '9.5px',
                letterSpacing: '0.13em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
              }}
            >
              Trading P&L
            </span>{' '}
            <span
              style={{
                fontSize: '15px',
                fontWeight: '600',
                fontVariantNumeric: 'tabular-nums',
                color: 'var(--pos)',
                whiteSpace: 'nowrap',
              }}
            >
              {dc.t(m.eqPnl)}
            </span>{' '}
            <span style={dc.css(`font-size:11px;font-weight:600;color:${dc.s(m.eqPnlPctCol)}`)}>
              {dc.t(m.eqPnlPct)}
            </span>{' '}
          </div>{' '}
        </div>{' '}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit,minmax(420px,1fr))',
            gap: '12px',
            alignItems: 'stretch',
          }}
        >
          {' '}
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '14px 18px 12px',
              display: 'flex',
              flexDirection: 'column',
              gap: '11px',
              minWidth: '0',
            }}
          >
            {' '}
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'space-between',
                gap: '14px',
                flexWrap: 'wrap',
              }}
            >
              {' '}
              <div style={{ minWidth: '180px' }}>
                {' '}
                <div
                  style={{
                    fontSize: '9.5px',
                    letterSpacing: '0.13em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Equity curve
                </div>{' '}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'baseline',
                    gap: '9px',
                    marginTop: '2px',
                    flexWrap: 'wrap',
                  }}
                >
                  {' '}
                  <span
                    style={{
                      fontSize: '22px',
                      fontWeight: '600',
                      letterSpacing: '-0.02em',
                      fontVariantNumeric: 'tabular-nums',
                      lineHeight: '1.1',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {dc.t(m.mcValue)}
                  </span>{' '}
                  <span
                    style={dc.css(
                      `font-size:11.5px;font-weight:600;font-variant-numeric:tabular-nums;color:${dc.s(m.mcDeltaCol)};white-space:nowrap`,
                    )}
                  >
                    {dc.t(m.mcDelta)}
                  </span>{' '}
                </div>{' '}
              </div>{' '}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '2px',
                  padding: '3px',
                  borderRadius: '99px',
                  border: '1px solid var(--l8)',
                  flex: 'none',
                }}
              >
                {' '}
                {(m.mcRanges ?? []).map((r, i4) => (
                  <Fragment key={i4}>
                    {' '}
                    <SegmentedOption
                      bg={r?.bg}
                      fg={r?.fg}
                      fw={r?.fw}
                      variant="a"
                      onClick={r?.go}
                      hoverClass="scp-4f3e86a"
                    >
                      {dc.t(r?.label)}
                    </SegmentedOption>{' '}
                  </Fragment>
                ))}{' '}
              </div>{' '}
            </div>{' '}
            <div
              style={{
                flex: '1',
                minHeight: '0',
                display: 'flex',
                alignItems: 'stretch',
                gap: '16px',
                flexWrap: 'wrap',
              }}
            >
              {' '}
              <div
                style={{
                  flex: '0 1 150px',
                  minWidth: '132px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '1px',
                }}
              >
                {' '}
                {(m.mcAccts ?? []).map((a, i5) => (
                  <Fragment key={i5}>
                    {' '}
                    <button
                      className="scp-55bc9c6"
                      onClick={a?.go}
                      title={dc.a(a?.title)}
                      style={dc.css(
                        `display:flex;align-items:center;gap:8px;width:100%;padding:5px 7px;border-radius:8px;border:none;background:${dc.s(a?.bg)};color:${dc.s(a?.fg)};opacity:${dc.s(a?.op)};font-size:12px;font-weight:${dc.s(a?.fw)};cursor:pointer;text-align:left`,
                      )}
                    >
                      {' '}
                      <span
                        style={dc.css(
                          `width:7px;height:7px;border-radius:2px;background:${dc.s(a?.dot)};opacity:${dc.s(a?.dotOp)};flex:none`,
                        )}
                      ></span>{' '}
                      <span
                        style={{
                          flex: '1',
                          minWidth: '0',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {dc.t(a?.name)}
                      </span>{' '}
                    </button>{' '}
                  </Fragment>
                ))}{' '}
              </div>{' '}
              <div
                style={{
                  flex: '1 1 340px',
                  minWidth: '280px',
                  minHeight: '0',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '0',
                }}
              >
                {' '}
                <div style={{ position: 'relative', flex: '1', minHeight: '150px' }}>
                  {' '}
                  <div
                    style={{
                      position: 'absolute',
                      inset: '0',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      pointerEvents: 'none',
                    }}
                  >
                    {' '}
                    {(m.mcGrid ?? []).map((g, i6) => (
                      <Fragment key={i6}>
                        {' '}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                          {' '}
                          <span
                            style={{
                              width: '46px',
                              flex: 'none',
                              textAlign: 'right',
                              fontSize: '9px',
                              color: 'var(--faint)',
                              fontVariantNumeric: 'tabular-nums',
                            }}
                          >
                            {dc.t(g?.label)}
                          </span>{' '}
                          <span style={{ flex: '1', height: '1px', background: 'var(--l6)' }}></span>{' '}
                        </div>{' '}
                      </Fragment>
                    ))}{' '}
                  </div>{' '}
                  <svg
                    aria-hidden="true"
                    viewBox="0 0 1000 300"
                    preserveAspectRatio="none"
                    style={{
                      position: 'absolute',
                      left: '53px',
                      top: '0',
                      width: 'calc(100% - 53px)',
                      height: '100%',
                    }}
                  >
                    {' '}
                    <defs>
                      {' '}
                      <linearGradient id="mceqg" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0" stopColor={dc.a(m.mcPrimaryCol)} stopOpacity="0.13"></stop>
                        <stop offset="1" stopColor={dc.a(m.mcPrimaryCol)} stopOpacity="0"></stop>
                      </linearGradient>{' '}
                      <filter id="mcblur" x="-6%" y="-16%" width="112%" height="132%">
                        <feGaussianBlur stdDeviation="2.2"></feGaussianBlur>
                      </filter>{' '}
                    </defs>{' '}
                    <path d={dc.a(m.mcAreaD)} fill="url(#mceqg)"></path>{' '}
                    {(m.mcCurves ?? []).map((c, i7) => (
                      <Fragment key={i7}>
                        {' '}
                        <path
                          d={dc.a(c?.d)}
                          fill="none"
                          stroke={dc.a(c?.col)}
                          strokeWidth={dc.a(c?.w)}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          opacity={dc.a(c?.op)}
                          filter={dc.a(c?.fx)}
                          vectorEffect="non-scaling-stroke"
                        ></path>{' '}
                      </Fragment>
                    ))}{' '}
                    <path
                      d={dc.a(m.mcPrimaryD)}
                      fill="none"
                      stroke={dc.a(m.mcPrimaryCol)}
                      strokeWidth="2.6"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      vectorEffect="non-scaling-stroke"
                    ></path>{' '}
                    {m.mcHoverOn ? (
                      <>
                        {' '}
                        <line
                          x1={dc.a(m.mcHoverX)}
                          y1="0"
                          x2={dc.a(m.mcHoverX)}
                          y2="300"
                          stroke="var(--l14)"
                          strokeDasharray="4 5"
                          vectorEffect="non-scaling-stroke"
                        ></line>{' '}
                      </>
                    ) : null}{' '}
                  </svg>{' '}
                  {m.mcHoverOn ? (
                    <>
                      {' '}
                      <div
                        style={dc.css(
                          `position:absolute;left:${dc.s(m.mcDotLeft)};top:${dc.s(m.mcDotTop)};width:9px;height:9px;margin:-4.5px 0 0 -4.5px;border-radius:50%;background:${dc.s(m.mcPrimaryCol)};box-shadow:0 0 0 2.5px var(--surface);pointer-events:none`,
                        )}
                      ></div>{' '}
                      <div
                        style={dc.css(
                          `position:absolute;left:${dc.s(m.mcTipLeft)};top:4px;transform:translateX(-50%);pointer-events:none;z-index:6;min-width:186px;border-radius:12px;border:1px solid var(--card-line);background:var(--surface);box-shadow:var(--shadow-float);padding:9px 11px;display:flex;flex-direction:column;gap:5px`,
                        )}
                      >
                        {' '}
                        <div
                          style={{
                            fontSize: '9.5px',
                            letterSpacing: '0.1em',
                            textTransform: 'uppercase',
                            color: 'var(--muted2)',
                            fontWeight: '600',
                          }}
                        >
                          {dc.t(m.mcTipPeriod)}
                        </div>{' '}
                        {(m.mcTipRows ?? []).map((t, i8) => (
                          <Fragment key={i8}>
                            {' '}
                            <div
                              style={dc.css(`display:flex;align-items:center;gap:8px;opacity:${dc.s(t?.op)}`)}
                            >
                              {' '}
                              <span
                                style={dc.css(
                                  `width:9px;height:3px;border-radius:99px;background:${dc.s(t?.col)};flex:none`,
                                )}
                              ></span>{' '}
                              <span
                                style={dc.css(
                                  `flex:1;min-width:0;font-size:11px;font-weight:${dc.s(t?.fw)};color:var(--text-mid);white-space:nowrap;overflow:hidden;text-overflow:ellipsis`,
                                )}
                              >
                                {dc.t(t?.name)}
                              </span>{' '}
                              <span
                                style={dc.css(
                                  `font-size:11px;font-weight:${dc.s(t?.fw)};font-variant-numeric:tabular-nums;white-space:nowrap`,
                                )}
                              >
                                {dc.t(t?.val)}
                              </span>{' '}
                              <span
                                style={dc.css(
                                  `font-size:10px;font-variant-numeric:tabular-nums;color:${dc.s(t?.chgCol)};white-space:nowrap;width:48px;text-align:right`,
                                )}
                              >
                                {dc.t(t?.chg)}
                              </span>{' '}
                            </div>{' '}
                          </Fragment>
                        ))}{' '}
                      </div>{' '}
                    </>
                  ) : null}{' '}
                  <div
                    onMouseLeave={m.mcLeave}
                    style={{
                      position: 'absolute',
                      left: '53px',
                      top: '0',
                      right: '0',
                      bottom: '0',
                      display: 'flex',
                    }}
                  >
                    {' '}
                    {(m.mcZones ?? []).map((z, i9) => (
                      <Fragment key={i9}>
                        {' '}
                        <div
                          onMouseEnter={z?.on}
                          onClick={z?.click}
                          role="button"
                          tabIndex={-1}
                          aria-label={dc.a(z?.aria)}
                          style={{ flex: '1', minWidth: '0', height: '100%', cursor: 'pointer' }}
                        ></div>{' '}
                      </Fragment>
                    ))}{' '}
                  </div>{' '}
                </div>{' '}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    height: '30px',
                    boxSizing: 'border-box',
                    padding: '8px 0 0 53px',
                    marginTop: '2px',
                    borderTop: '1px solid var(--l6)',
                  }}
                >
                  {' '}
                  {(m.mcX ?? []).map((x, i10) => (
                    <Fragment key={i10}>
                      {' '}
                      <span
                        style={dc.css(
                          `flex:1;min-width:0;text-align:center;font-size:9px;font-weight:${dc.s(x?.fw)};color:${dc.s(x?.fg)};white-space:nowrap`,
                        )}
                      >
                        {dc.t(x?.label)}
                      </span>{' '}
                    </Fragment>
                  ))}{' '}
                </div>{' '}
              </div>{' '}
            </div>{' '}
          </div>{' '}
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '14px 18px 12px',
              display: 'flex',
              flexDirection: 'column',
              gap: '11px',
              minWidth: '0',
            }}
          >
            {' '}
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'space-between',
                gap: '14px',
                flexWrap: 'wrap',
              }}
            >
              {' '}
              <div style={{ minWidth: '170px' }}>
                {' '}
                <div
                  style={{
                    fontSize: '9.5px',
                    letterSpacing: '0.13em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  P&L calendar
                </div>{' '}
                <div
                  style={{
                    fontSize: '15px',
                    fontWeight: '600',
                    letterSpacing: '-0.01em',
                    marginTop: '3px',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {dc.t(m.calPeriod)}
                </div>{' '}
              </div>{' '}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '2px',
                  padding: '3px',
                  borderRadius: '99px',
                  border: '1px solid var(--l8)',
                  flex: 'none',
                }}
              >
                {' '}
                <PagerButton
                  color={m.calPrevFg}
                  cursor={m.calPrevCur}
                  icon="ph-caret-left"
                  onClick={m.calPrev}
                  title={dc.s(m.calPrevTitle)}
                  aria-label={dc.s(m.calPrevTitle)}
                  disabled={!!m.calAtStart}
                  hoverClass="scp-4f3e86a"
                />{' '}
                <span
                  style={{
                    minWidth: '72px',
                    textAlign: 'center',
                    fontSize: '10.5px',
                    fontWeight: '600',
                    color: 'var(--text)',
                  }}
                >
                  {dc.t(m.calMonthShort)}
                </span>{' '}
                <PagerButton
                  color={m.calNextFg}
                  cursor={m.calNextCur}
                  icon="ph-caret-right"
                  onClick={m.calNext}
                  title={dc.s(m.calNextTitle)}
                  aria-label={dc.s(m.calNextTitle)}
                  disabled={!!m.calAtEnd}
                  hoverClass="scp-4f3e86a"
                />{' '}
              </div>{' '}
            </div>{' '}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: '1' }}>
              {' '}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: '4px' }}>
                {' '}
                {(m.calDow ?? []).map((d, i11) => (
                  <Fragment key={i11}>
                    {' '}
                    <span
                      style={{
                        fontSize: '9px',
                        letterSpacing: '0.1em',
                        textTransform: 'uppercase',
                        color: 'var(--muted2)',
                        fontWeight: '600',
                        textAlign: 'center',
                      }}
                    >
                      {dc.t(d)}
                    </span>{' '}
                  </Fragment>
                ))}{' '}
              </div>{' '}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: '4px', flex: '1' }}>
                {' '}
                {(m.calCells ?? []).map((c, i12) => (
                  <Fragment key={i12}>
                    {' '}
                    <button
                      className="scp-d9c1ec4"
                      onClick={c?.open}
                      disabled={!!c?.dis}
                      onMouseEnter={c?.hEnter}
                      onMouseMove={c?.hMove}
                      onMouseLeave={c?.hLeave}
                      aria-label={dc.a(c?.tip)}
                      style={dc.css(
                        `min-height:44px;border-radius:9px;border:1px solid ${dc.s(c?.bd)};background:${dc.s(c?.bg)};background-image:${dc.s(c?.img)};background-size:6px 6px;box-shadow:${dc.s(c?.ring)};display:flex;flex-direction:column;align-items:stretch;justify-content:space-between;padding:5px 6px;overflow:hidden;cursor:${dc.s(c?.cur)};font:inherit;text-align:left`,
                      )}
                      aria-hidden={dc.b(c?.pad)}
                    >
                      {' '}
                      <span
                        style={dc.css(
                          `font-size:9px;font-weight:${dc.s(c?.dayFw)};color:${dc.s(c?.dayFg)};font-variant-numeric:tabular-nums;line-height:1`,
                        )}
                      >
                        {dc.t(c?.day)}
                      </span>{' '}
                      <span
                        style={dc.css(
                          `font-size:10px;font-weight:600;color:${dc.s(c?.fg)};font-variant-numeric:tabular-nums;line-height:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis`,
                        )}
                      >
                        {dc.t(c?.val)}
                      </span>{' '}
                    </button>{' '}
                  </Fragment>
                ))}{' '}
              </div>{' '}
            </div>{' '}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '14px',
                height: '30px',
                boxSizing: 'border-box',
                paddingTop: '8px',
                marginTop: '2px',
                overflow: 'hidden',
                borderTop: '1px solid var(--l6)',
              }}
            >
              {' '}
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: '10.5px',
                  color: 'var(--muted)',
                }}
              >
                <span
                  style={{
                    width: '14px',
                    height: '8px',
                    borderRadius: '3px',
                    background: 'color-mix(in srgb, var(--pnl-p4) 22%, transparent)',
                    border: '1px solid color-mix(in srgb, var(--pnl-p4) 22%, transparent)',
                    flex: 'none',
                  }}
                ></span>
                Winning day
              </span>{' '}
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: '10.5px',
                  color: 'var(--muted)',
                }}
              >
                <span
                  style={{
                    width: '14px',
                    height: '8px',
                    borderRadius: '3px',
                    background: 'color-mix(in srgb, var(--pnl-n4) 22%, transparent)',
                    border: '1px solid color-mix(in srgb, var(--pnl-n4) 22%, transparent)',
                    flex: 'none',
                  }}
                ></span>
                Losing day
              </span>{' '}
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: '10.5px',
                  color: 'var(--muted)',
                }}
              >
                <span
                  style={{
                    width: '14px',
                    height: '8px',
                    borderRadius: '3px',
                    backgroundImage: 'repeating-linear-gradient(45deg,var(--l10) 0 2px,transparent 2px 5px)',
                    border: '1px dashed var(--l12)',
                    flex: 'none',
                  }}
                ></span>
                No trading
              </span>{' '}
            </div>{' '}
          </div>{' '}
        </div>{' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            padding: '14px 18px 12px',
            display: 'flex',
            flexDirection: 'column',
            gap: '11px',
          }}
        >
          {' '}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '12px',
              flexWrap: 'wrap',
            }}
          >
            {' '}
            <span
              style={{
                fontSize: '9.5px',
                letterSpacing: '0.13em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
              }}
            >
              Performance
            </span>{' '}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '2px',
                padding: '3px',
                borderRadius: '99px',
                border: '1px solid var(--l8)',
                flex: 'none',
              }}
            >
              {' '}
              {(m.gaugeRanges ?? []).map((r, i13) => (
                <Fragment key={i13}>
                  {' '}
                  <SegmentedOption
                    bg={r?.bg}
                    fg={r?.fg}
                    fw={r?.fw}
                    variant="a"
                    onClick={r?.go}
                    hoverClass="scp-4f3e86a"
                  >
                    {dc.t(r?.label)}
                  </SegmentedOption>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
          </div>{' '}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', alignItems: 'stretch' }}>
            {' '}
            {(m.gauges ?? []).map((g, i14) => (
              <Fragment key={i14}>
                {' '}
                <div
                  style={dc.css(
                    `min-width:0;display:flex;flex-direction:column;gap:8px;padding:0 14px;border-left:${dc.s(g?.bd)}`,
                  )}
                >
                  {' '}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: '8px',
                    }}
                  >
                    {' '}
                    <span
                      style={{
                        fontSize: '9.5px',
                        letterSpacing: '0.13em',
                        textTransform: 'uppercase',
                        color: 'var(--muted2)',
                        fontWeight: '600',
                      }}
                    >
                      {dc.t(g?.label)}
                    </span>{' '}
                    <i
                      className="ph ph-info"
                      title={dc.a(g?.tip)}
                      style={{ fontSize: '12px', color: 'var(--ghost)', cursor: 'help' }}
                    ></i>{' '}
                  </div>{' '}
                  <div
                    onMouseEnter={g?.hEnter}
                    onMouseMove={g?.hMove}
                    onMouseLeave={g?.hLeave}
                    onClick={g?.click}
                    role="button"
                    tabIndex={0}
                    style={{
                      position: 'relative',
                      width: '100%',
                      maxWidth: '236px',
                      alignSelf: 'center',
                      cursor: 'pointer',
                    }}
                  >
                    {' '}
                    <svg
                      role="img"
                      aria-label={dc.a(g?.aria)}
                      viewBox="0 0 200 114"
                      style={{ width: '100%', display: 'block' }}
                    >
                      {' '}
                      {(g?.ticks ?? []).map((k, i15) => (
                        <Fragment key={i15}>
                          {' '}
                          <line
                            x1={dc.a(k?.x1)}
                            y1={dc.a(k?.y1)}
                            x2={dc.a(k?.x2)}
                            y2={dc.a(k?.y2)}
                            stroke={dc.a(k?.col)}
                            strokeWidth={dc.a(k?.w)}
                            strokeLinecap="round"
                            opacity={dc.a(k?.op)}
                          ></line>{' '}
                        </Fragment>
                      ))}{' '}
                    </svg>{' '}
                    <div
                      style={{
                        position: 'absolute',
                        left: '0',
                        right: '0',
                        bottom: '8px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '1px',
                        pointerEvents: 'none',
                      }}
                    >
                      {' '}
                      <span
                        style={{
                          fontSize: '27px',
                          fontWeight: '600',
                          letterSpacing: '-0.02em',
                          fontVariantNumeric: 'tabular-nums',
                          lineHeight: '1',
                        }}
                      >
                        {dc.t(g?.pct)}
                      </span>{' '}
                      <span style={{ fontSize: '10px', color: 'var(--muted)' }}>{dc.t(g?.caption)}</span>{' '}
                    </div>{' '}
                    <span
                      style={{
                        position: 'absolute',
                        left: '1px',
                        bottom: '1px',
                        fontSize: '9px',
                        color: 'var(--faint)',
                        fontVariantNumeric: 'tabular-nums',
                      }}
                    >
                      {dc.t(g?.min)}
                    </span>{' '}
                    <span
                      style={{
                        position: 'absolute',
                        right: '1px',
                        bottom: '1px',
                        fontSize: '9px',
                        color: 'var(--faint)',
                        fontVariantNumeric: 'tabular-nums',
                      }}
                    >
                      {dc.t(g?.max)}
                    </span>{' '}
                  </div>{' '}
                  <div
                    style={{
                      display: 'flex',
                      gap: '10px',
                      paddingTop: '9px',
                      borderTop: '1px solid var(--l6)',
                    }}
                  >
                    {' '}
                    {(g?.figs ?? []).map((f, i16) => (
                      <Fragment key={i16}>
                        {' '}
                        <div
                          onMouseEnter={f?.hEnter}
                          onMouseMove={f?.hMove}
                          onMouseLeave={f?.hLeave}
                          style={{ flex: '1', minWidth: '0' }}
                        >
                          {' '}
                          <div
                            style={{
                              fontSize: '9px',
                              letterSpacing: '0.11em',
                              textTransform: 'uppercase',
                              color: 'var(--muted2)',
                              fontWeight: '600',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {dc.t(f?.label)}
                          </div>{' '}
                          <div
                            style={dc.css(
                              `font-size:14px;font-weight:600;font-variant-numeric:tabular-nums;margin-top:2px;color:${dc.s(f?.col)}`,
                            )}
                          >
                            {dc.t(f?.value)}
                          </div>{' '}
                        </div>{' '}
                      </Fragment>
                    ))}{' '}
                  </div>{' '}
                </div>{' '}
              </Fragment>
            ))}{' '}
          </div>{' '}
        </div>{' '}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit,minmax(400px,1fr))',
            gap: '12px',
            alignItems: 'stretch',
          }}
        >
          {' '}
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '14px 18px 12px',
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              minWidth: '0',
            }}
          >
            {' '}
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                gap: '12px',
                flexWrap: 'wrap',
              }}
            >
              {' '}
              <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                {' '}
                <span
                  style={{
                    fontSize: '9.5px',
                    letterSpacing: '0.13em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  PointFive Score
                </span>{' '}
                <i
                  className="ph ph-info"
                  title={dc.a(m.pfTip)}
                  style={{ fontSize: '12px', color: 'var(--ghost)', cursor: 'help' }}
                ></i>{' '}
              </div>{' '}
              <span style={{ fontSize: '10.5px', color: 'var(--muted)', whiteSpace: 'nowrap' }}>
                Progressive · full trade history
              </span>{' '}
            </div>{' '}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
              {' '}
              <span
                title={dc.a(m.pfScopeTip)}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: '10.5px',
                  color: 'var(--muted)',
                }}
              >
                <span
                  style={dc.css(
                    `width:7px;height:7px;border-radius:2px;background:${dc.s(m.pfScopeCol)};flex:none`,
                  )}
                ></span>
                {dc.t(m.pfScope)}
              </span>{' '}
              <span style={{ fontSize: '10.5px', color: 'var(--faint)' }}>
                {'as of '}
                {dc.t(m.pfAsOf)}
              </span>{' '}
              <span style={{ flex: '1' }}></span>{' '}
              {m.pfDrilled ? (
                <>
                  {' '}
                  <button
                    className="scp-4f3e86a"
                    onClick={m.pfBack}
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '5px',
                      fontSize: '10.5px',
                      fontWeight: '600',
                      padding: '4px 10px',
                      borderRadius: '99px',
                      border: '1px solid var(--l10)',
                      background: 'transparent',
                      color: 'var(--text-mid)',
                      cursor: 'pointer',
                    }}
                  >
                    <i className="ph ph-arrow-left" style={{ fontSize: '11px' }}></i>All five pillars
                  </button>{' '}
                </>
              ) : null}{' '}
            </div>{' '}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '18px',
                flexWrap: 'wrap',
              }}
            >
              {' '}
              <div
                onMouseLeave={m.pfLeave}
                style={{
                  position: 'relative',
                  flex: '1 1 240px',
                  minWidth: '212px',
                  maxWidth: '318px',
                  aspectRatio: '1',
                }}
              >
                {' '}
                <svg
                  role="img"
                  aria-label={dc.a(m.pfAria)}
                  viewBox="0 0 300 300"
                  style={{ width: '100%', height: '100%', display: 'block' }}
                >
                  {' '}
                  <defs>
                    {' '}
                    <pattern
                      id="pfhatch"
                      width="6"
                      height="6"
                      patternUnits="userSpaceOnUse"
                      patternTransform="rotate(45)"
                    >
                      {' '}
                      <line
                        x1="0"
                        y1="0"
                        x2="0"
                        y2="6"
                        stroke="var(--muted2)"
                        strokeWidth="2.2"
                        opacity="0.45"
                      ></line>{' '}
                    </pattern>{' '}
                  </defs>{' '}
                  {(m.pfSectors ?? []).map((s, i17) => (
                    <Fragment key={i17}>
                      {' '}
                      <path
                        onMouseEnter={s?.on}
                        onFocus={s?.on}
                        onClick={s?.click}
                        onKeyDown={s?.key}
                        tabIndex={dc.n(s?.tab)}
                        role={dc.a(s?.role)}
                        aria-label={dc.a(s?.aria)}
                        d={dc.a(s?.d)}
                        fill={dc.a(s?.fill)}
                        stroke={dc.a(s?.stroke)}
                        strokeWidth={dc.a(s?.sw)}
                        strokeDasharray={dc.a(s?.dash)}
                        transform={dc.tx(s?.tf)}
                        style={{
                          cursor: 'pointer',
                          outline: 'none',
                          transformOrigin: '150px 150px',
                          transition: 'transform 160ms cubic-bezier(0.22,0.61,0.36,1)',
                        }}
                      ></path>{' '}
                    </Fragment>
                  ))}{' '}
                </svg>{' '}
                <div
                  style={{
                    position: 'absolute',
                    inset: '0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    pointerEvents: 'none',
                  }}
                >
                  {' '}
                  <span
                    style={{
                      fontSize: '40px',
                      fontWeight: '600',
                      letterSpacing: '-0.03em',
                      lineHeight: '1',
                      fontVariantNumeric: 'tabular-nums',
                    }}
                  >
                    {dc.t(m.pfCenterValue)}
                  </span>{' '}
                </div>{' '}
                {m.pfHoverOn ? (
                  <>
                    {' '}
                    <div
                      style={dc.css(
                        `position:absolute;left:${dc.s(m.pfTipLeft)};top:${dc.s(m.pfTipTop)};transform:${dc.s(m.pfTipTf)};pointer-events:none;z-index:6;min-width:172px;max-width:232px;border-radius:11px;border:1px solid var(--card-line);background:var(--surface);box-shadow:var(--shadow-float);padding:8px 10px;display:flex;flex-direction:column;gap:3px`,
                      )}
                    >
                      {' '}
                      <span
                        style={{
                          fontSize: '9.5px',
                          letterSpacing: '0.1em',
                          textTransform: 'uppercase',
                          color: 'var(--muted2)',
                          fontWeight: '600',
                        }}
                      >
                        {dc.t(m.pfTipKicker)}
                      </span>{' '}
                      <span style={{ fontSize: '12px', fontWeight: '600', color: 'var(--text)' }}>
                        {dc.t(m.pfTipTitle)}
                      </span>{' '}
                      <div style={{ display: 'flex', alignItems: 'baseline', gap: '7px' }}>
                        {' '}
                        <span
                          style={{ fontSize: '13px', fontWeight: '600', fontVariantNumeric: 'tabular-nums' }}
                        >
                          {dc.t(m.pfTipPoints)}
                        </span>{' '}
                        <span
                          style={dc.css(
                            `font-size:10.5px;font-weight:600;color:${dc.s(m.pfTipPctCol)};font-variant-numeric:tabular-nums`,
                          )}
                        >
                          {dc.t(m.pfTipPct)}
                        </span>{' '}
                      </div>{' '}
                      <span style={{ fontSize: '10.5px', color: 'var(--muted)', lineHeight: '1.45' }}>
                        {dc.t(m.pfTipNote)}
                      </span>{' '}
                    </div>{' '}
                  </>
                ) : null}{' '}
              </div>{' '}
              <div
                style={{
                  flex: '0 1 152px',
                  minWidth: '132px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                }}
              >
                {' '}
                <div>
                  {' '}
                  <div
                    style={{
                      fontSize: '8.5px',
                      letterSpacing: '0.11em',
                      textTransform: 'uppercase',
                      color: 'var(--muted2)',
                      fontWeight: '600',
                    }}
                  >
                    {dc.t(m.pfStatKicker)}
                  </div>{' '}
                  <div
                    style={dc.css(
                      `font-size:13.5px;font-weight:600;color:${dc.s(m.pfTierCol)};margin-top:2px`,
                    )}
                  >
                    {dc.t(m.pfCenterTier)}
                  </div>{' '}
                </div>{' '}
                <div>
                  {' '}
                  <div
                    style={{
                      fontSize: '8.5px',
                      letterSpacing: '0.11em',
                      textTransform: 'uppercase',
                      color: 'var(--muted2)',
                      fontWeight: '600',
                    }}
                  >
                    Confidence
                  </div>{' '}
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px', marginTop: '2px' }}>
                    {' '}
                    <span
                      style={dc.css(
                        `font-size:17px;font-weight:600;font-variant-numeric:tabular-nums;color:${dc.s(m.pfConfCol)}`,
                      )}
                    >
                      {dc.t(m.pfConf)}
                    </span>{' '}
                  </div>{' '}
                  <div
                    style={{
                      height: '4px',
                      borderRadius: '99px',
                      background: 'var(--l7)',
                      overflow: 'hidden',
                      marginTop: '5px',
                    }}
                  >
                    <div
                      style={dc.css(
                        `width:${dc.s(m.pfConf)};height:100%;border-radius:99px;background:${dc.s(m.pfConfCol)}`,
                      )}
                    ></div>
                  </div>{' '}
                  <div
                    style={{ fontSize: '9.5px', color: 'var(--muted)', marginTop: '4px', lineHeight: '1.45' }}
                  >
                    {dc.t(m.pfConfNote)}
                  </div>{' '}
                </div>{' '}
                <div style={{ display: 'flex', gap: '12px' }}>
                  {' '}
                  <div style={{ minWidth: '0' }}>
                    {' '}
                    <div
                      style={{
                        fontSize: '8.5px',
                        letterSpacing: '0.11em',
                        textTransform: 'uppercase',
                        color: 'var(--muted2)',
                        fontWeight: '600',
                      }}
                    >
                      Percentile
                    </div>{' '}
                    <div
                      style={{
                        fontSize: '13.5px',
                        fontWeight: '600',
                        fontVariantNumeric: 'tabular-nums',
                        marginTop: '2px',
                      }}
                    >
                      {dc.t(m.pfPercentile)}
                    </div>{' '}
                  </div>{' '}
                  <div style={{ minWidth: '0' }}>
                    {' '}
                    <div
                      style={{
                        fontSize: '8.5px',
                        letterSpacing: '0.11em',
                        textTransform: 'uppercase',
                        color: 'var(--muted2)',
                        fontWeight: '600',
                      }}
                    >
                      Maximum
                    </div>{' '}
                    <div
                      style={{
                        fontSize: '13.5px',
                        fontWeight: '600',
                        fontVariantNumeric: 'tabular-nums',
                        marginTop: '2px',
                        color: 'var(--text-mid)',
                      }}
                    >
                      {dc.t(m.pfMaxLabel)}
                    </div>{' '}
                  </div>{' '}
                </div>{' '}
              </div>{' '}
            </div>{' '}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                flexWrap: 'wrap',
                paddingTop: '9px',
                borderTop: '1px solid var(--l6)',
              }}
            >
              {' '}
              {(m.pfLegend ?? []).map((l, i18) => (
                <Fragment key={i18}>
                  {' '}
                  <span
                    title={dc.a(l?.tip)}
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                      fontSize: '10px',
                      color: 'var(--muted)',
                    }}
                  >
                    {' '}
                    <span
                      style={dc.css(
                        `width:10px;height:10px;border-radius:2px;background:${dc.s(l?.col)};background-image:${dc.s(l?.img)};border:1px ${dc.s(l?.bdStyle)} ${dc.s(l?.bd)};flex:none`,
                      )}
                    ></span>
                    {dc.t(l?.name)}{' '}
                  </span>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
              {' '}
              <div
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}
              >
                {' '}
                <span
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  {'Score evolution · '}
                  {dc.t(m.pfSnapRes)}
                </span>{' '}
                <span style={{ fontSize: '10px', color: 'var(--muted)' }}>
                  each point scored on all history up to that date
                </span>{' '}
              </div>{' '}
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: '3px', height: '44px' }}>
                {' '}
                {(m.pfSnaps ?? []).map((p, i19) => (
                  <Fragment key={i19}>
                    {' '}
                    <button
                      className="scp-18367cd"
                      onClick={p?.go}
                      onMouseEnter={p?.hEnter}
                      onMouseMove={p?.hMove}
                      onMouseLeave={p?.hLeave}
                      aria-label={dc.a(p?.tip)}
                      style={{
                        flex: '1',
                        minWidth: '0',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-end',
                        gap: '3px',
                        padding: '0',
                        border: 'none',
                        background: 'transparent',
                        cursor: 'pointer',
                      }}
                    >
                      {' '}
                      <div
                        style={dc.css(
                          `width:100%;height:${dc.s(p?.h)};min-height:4px;border-radius:3px;background:${dc.s(p?.col)};opacity:${dc.s(p?.op)}`,
                        )}
                      ></div>{' '}
                      <span
                        style={dc.css(
                          `font-size:8px;color:${dc.s(p?.fg)};font-weight:${dc.s(p?.fw)};white-space:nowrap;overflow:hidden;text-overflow:ellipsis`,
                        )}
                      >
                        {dc.t(p?.label)}
                      </span>{' '}
                    </button>{' '}
                  </Fragment>
                ))}{' '}
              </div>{' '}
            </div>{' '}
            <div
              style={{
                borderRadius: '12px',
                border: '1px solid var(--l8)',
                background: 'var(--l3)',
                padding: '11px 12px',
                display: 'flex',
                flexDirection: 'column',
                gap: '6px',
              }}
            >
              {' '}
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {' '}
                <i
                  className={`ph ${dc.s(m.pfDetailIcon)}`}
                  style={dc.css(`font-size:13px;color:${dc.s(m.pfDetailCol)};flex:none`)}
                ></i>{' '}
                <span style={{ fontSize: '12px', fontWeight: '600', flex: '1', minWidth: '0' }}>
                  {dc.t(m.pfDetailTitle)}
                </span>{' '}
                <span
                  style={{
                    fontSize: '11px',
                    fontWeight: '600',
                    fontVariantNumeric: 'tabular-nums',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {dc.t(m.pfDetailPoints)}
                </span>{' '}
              </div>{' '}
              <div style={{ fontSize: '10.5px', color: 'var(--muted)', lineHeight: '1.5' }}>
                {dc.t(m.pfDetailBody)}
              </div>{' '}
              {m.pfDetailRows ? (
                <>
                  {' '}
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fit,minmax(112px,1fr))',
                      gap: '8px',
                      paddingTop: '7px',
                      borderTop: '1px solid var(--l6)',
                    }}
                  >
                    {' '}
                    {(m.pfDetailRows ?? []).map((d, i20) => (
                      <Fragment key={i20}>
                        {' '}
                        <div style={{ minWidth: '0' }}>
                          {' '}
                          <div
                            style={{
                              fontSize: '8.5px',
                              letterSpacing: '0.1em',
                              textTransform: 'uppercase',
                              color: 'var(--muted2)',
                              fontWeight: '600',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {dc.t(d?.label)}
                          </div>{' '}
                          <div
                            style={dc.css(
                              `font-size:11.5px;font-weight:600;font-variant-numeric:tabular-nums;margin-top:2px;color:${dc.s(d?.col)}`,
                            )}
                          >
                            {dc.t(d?.value)}
                          </div>{' '}
                        </div>{' '}
                      </Fragment>
                    ))}{' '}
                  </div>{' '}
                </>
              ) : null}{' '}
            </div>{' '}
            {m.pfTierReduced ? (
              <>
                {' '}
                <div
                  style={{
                    display: 'flex',
                    gap: '8px',
                    alignItems: 'flex-start',
                    borderRadius: '12px',
                    border: '1px solid color-mix(in srgb, var(--amb) 35%, transparent)',
                    background: 'color-mix(in srgb, var(--amb) 10%, transparent)',
                    padding: '10px 12px',
                  }}
                >
                  {' '}
                  <i
                    className="ph ph-warning-circle"
                    style={{ fontSize: '13px', color: 'var(--amb-2)', flex: 'none', marginTop: '1px' }}
                  ></i>{' '}
                  <span style={{ fontSize: '10.5px', color: 'var(--text-mid)', lineHeight: '1.5' }}>
                    {dc.t(m.pfTierNote)}
                  </span>{' '}
                </div>{' '}
              </>
            ) : null}{' '}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit,minmax(104px,1fr))',
                gap: '9px',
                paddingTop: '9px',
                borderTop: '1px solid var(--l6)',
              }}
            >
              {' '}
              {(m.pfFacts ?? []).map((f, i21) => (
                <Fragment key={i21}>
                  {' '}
                  <div
                    onMouseEnter={f?.hEnter}
                    onMouseMove={f?.hMove}
                    onMouseLeave={f?.hLeave}
                    style={{ minWidth: '0' }}
                  >
                    {' '}
                    <div
                      style={{
                        fontSize: '8.5px',
                        letterSpacing: '0.1em',
                        textTransform: 'uppercase',
                        color: 'var(--muted2)',
                        fontWeight: '600',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {dc.t(f?.label)}
                    </div>{' '}
                    <div
                      style={dc.css(
                        `font-size:11.5px;font-weight:600;font-variant-numeric:tabular-nums;margin-top:2px;color:${dc.s(f?.col)};white-space:nowrap;overflow:hidden;text-overflow:ellipsis`,
                      )}
                    >
                      {dc.t(f?.value)}
                    </div>{' '}
                  </div>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
            <div style={{ fontSize: '9.5px', color: 'var(--muted2)', letterSpacing: '0.04em' }}>
              {dc.t(m.pfVersions)}
            </div>{' '}
          </div>{' '}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', minWidth: '0' }}>
            {' '}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: '12px' }}>
              {' '}
              {(m.miniStats ?? []).map((s, i22) => (
                <Fragment key={i22}>
                  {' '}
                  <div
                    onMouseEnter={s?.hEnter}
                    onMouseMove={s?.hMove}
                    onMouseLeave={s?.hLeave}
                    onClick={s?.click}
                    role="button"
                    tabIndex={0}
                    aria-label={dc.a(s?.tip)}
                    style={{
                      background: 'var(--surface)',
                      border: '1px solid var(--card-line)',
                      boxShadow: 'var(--shadow-card)',
                      borderRadius: '16px',
                      padding: '12px 14px 11px',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '7px',
                      minWidth: '0',
                      cursor: 'pointer',
                    }}
                  >
                    {' '}
                    <div
                      style={{
                        fontSize: '9px',
                        letterSpacing: '0.11em',
                        textTransform: 'uppercase',
                        color: 'var(--muted2)',
                        fontWeight: '600',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {dc.t(s?.label)}
                    </div>{' '}
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px', flexWrap: 'wrap' }}>
                      {' '}
                      <span
                        style={dc.css(
                          `font-size:19px;font-weight:600;letter-spacing:-0.02em;line-height:1.05;font-variant-numeric:tabular-nums;color:${dc.s(s?.col)};white-space:nowrap`,
                        )}
                      >
                        {dc.t(s?.value)}
                      </span>{' '}
                      <span
                        style={dc.css(
                          `font-size:10px;font-weight:600;font-variant-numeric:tabular-nums;color:${dc.s(s?.chgCol)};white-space:nowrap`,
                        )}
                      >
                        {dc.t(s?.chg)}
                      </span>{' '}
                    </div>{' '}
                    <div
                      style={{
                        height: '4px',
                        borderRadius: '99px',
                        background: 'var(--l7)',
                        overflow: 'hidden',
                      }}
                    >
                      <div
                        style={dc.css(
                          `width:${dc.s(s?.fill)};height:100%;border-radius:99px;background:${dc.s(s?.barCol)}`,
                        )}
                      ></div>
                    </div>{' '}
                    <div
                      style={{
                        fontSize: '9.5px',
                        color: 'var(--muted)',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {dc.t(s?.sub)}
                    </div>{' '}
                  </div>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
            {(m.pfMetrics ?? []).map((m, i23) => (
              <Fragment key={i23}>
                {' '}
                <div
                  style={{
                    background: 'var(--surface)',
                    border: '1px solid var(--card-line)',
                    boxShadow: 'var(--shadow-card)',
                    borderRadius: '16px',
                    padding: '14px 18px 12px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '9px',
                    flex: '1',
                    minHeight: '0',
                  }}
                >
                  {' '}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      justifyContent: 'space-between',
                      gap: '12px',
                    }}
                  >
                    {' '}
                    <div
                      onMouseEnter={m?.hEnter}
                      onMouseMove={m?.hMove}
                      onMouseLeave={m?.hLeave}
                      onClick={m?.click}
                      role="button"
                      tabIndex={0}
                      style={{ minWidth: '0', cursor: 'pointer' }}
                    >
                      {' '}
                      <div
                        style={{
                          fontSize: '9.5px',
                          letterSpacing: '0.13em',
                          textTransform: 'uppercase',
                          color: 'var(--muted2)',
                          fontWeight: '600',
                        }}
                      >
                        {dc.t(m?.label)}
                      </div>{' '}
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'baseline',
                          gap: '8px',
                          marginTop: '2px',
                          flexWrap: 'wrap',
                        }}
                      >
                        {' '}
                        <span
                          style={dc.css(
                            `font-size:22px;font-weight:600;letter-spacing:-0.02em;line-height:1.1;font-variant-numeric:tabular-nums;color:${dc.s(m?.col)};white-space:nowrap`,
                          )}
                        >
                          {dc.t(m?.value)}
                        </span>{' '}
                        <span
                          style={dc.css(
                            `font-size:11px;font-weight:600;color:${dc.s(m?.chgCol)};font-variant-numeric:tabular-nums;white-space:nowrap`,
                          )}
                        >
                          {dc.t(m?.chg)}
                        </span>{' '}
                      </div>{' '}
                    </div>{' '}
                    <i
                      className="ph ph-info"
                      title={dc.a(m?.tip)}
                      style={{ fontSize: '12px', color: 'var(--ghost)', cursor: 'help', flex: 'none' }}
                    ></i>{' '}
                  </div>{' '}
                  <div
                    style={{
                      flex: '1',
                      minHeight: '46px',
                      display: 'flex',
                      alignItems: 'flex-end',
                      gap: '3px',
                    }}
                  >
                    {' '}
                    {(m?.bars ?? []).map((b, i24) => (
                      <Fragment key={i24}>
                        {' '}
                        <div
                          onMouseEnter={b?.hEnter}
                          onMouseMove={b?.hMove}
                          onMouseLeave={b?.hLeave}
                          onClick={b?.click}
                          role="button"
                          tabIndex={0}
                          aria-label={dc.a(b?.tip)}
                          style={dc.css(
                            `flex:1;min-width:0;height:${dc.s(b?.h)};min-height:3px;border-radius:${dc.s(b?.rad)};background:${dc.s(b?.col)};opacity:${dc.s(b?.op)};cursor:pointer`,
                          )}
                        ></div>{' '}
                      </Fragment>
                    ))}{' '}
                  </div>{' '}
                  <div style={{ display: 'flex', gap: '3px', height: '11px', flex: 'none' }}>
                    {' '}
                    {(m?.bars ?? []).map((b, i25) => (
                      <Fragment key={i25}>
                        {' '}
                        <span
                          style={{
                            flex: '1',
                            minWidth: '0',
                            fontSize: '8.5px',
                            lineHeight: '11px',
                            color: 'var(--faint)',
                            textAlign: 'center',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          {dc.t(b?.label)}
                        </span>{' '}
                      </Fragment>
                    ))}{' '}
                  </div>{' '}
                  <div
                    style={{
                      display: 'flex',
                      gap: '12px',
                      paddingTop: '8px',
                      borderTop: '1px solid var(--l6)',
                    }}
                  >
                    {' '}
                    {(m?.figs ?? []).map((f, i26) => (
                      <Fragment key={i26}>
                        {' '}
                        <div
                          onMouseEnter={f?.hEnter}
                          onMouseMove={f?.hMove}
                          onMouseLeave={f?.hLeave}
                          style={{ flex: '1', minWidth: '0' }}
                        >
                          {' '}
                          <div
                            style={{
                              fontSize: '9px',
                              letterSpacing: '0.11em',
                              textTransform: 'uppercase',
                              color: 'var(--muted2)',
                              fontWeight: '600',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {dc.t(f?.label)}
                          </div>{' '}
                          <div
                            style={dc.css(
                              `font-size:13px;font-weight:600;font-variant-numeric:tabular-nums;margin-top:2px;color:${dc.s(f?.col)}`,
                            )}
                          >
                            {dc.t(f?.value)}
                          </div>{' '}
                        </div>{' '}
                      </Fragment>
                    ))}{' '}
                  </div>{' '}
                </div>{' '}
              </Fragment>
            ))}{' '}
          </div>{' '}
        </div>{' '}
      </div>{' '}
    </>
  );
}
